import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { BifIconNote, Button } from "banafo-design-system";
import { PUBLICDOCS_URL_FULL } from "src/app/config";
const Title = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "mb-150 d-flex align-items-center justify-content-between", children: [_jsx("h4", { className: "m-0 text-uppercase d-inline-block", children: t('Speech.to.text.api_') }), _jsxs(Button, { variant: "outline-dark", className: "text-uppercase text-nowrap with-icon end", href: `${PUBLICDOCS_URL_FULL}`, children: [t('Documentation_'), " ", _jsx(BifIconNote, {})] })] }));
};
export default Title;
